const hasPaginationNextItems = (pagination: Pagination): boolean => {
  if (!pagination) return false;

  const { currentPage, pagesCount } = pagination;

  if (!currentPage || !pagesCount) return false;

  return currentPage < pagesCount;
};

export default hasPaginationNextItems;
